// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorProductOptions = (client) => ({
    /**
     * `POST /vendor/product-options`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateProductOption
     * @source packages/modules/b2c-core/src/api/vendor/product-options/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/product-options", { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/product-options/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteProductOption
     * @source packages/modules/b2c-core/src/api/vendor/product-options/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/product-options/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/product-options`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListProductOptions
     * @source packages/modules/b2c-core/src/api/vendor/product-options/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/product-options", { method: "GET", query, headers }),
    /**
     * `POST /vendor/product-options/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateProductOption
     * @source packages/modules/b2c-core/src/api/vendor/product-options/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/product-options/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=product-options.js.map